import BackupSettings from './Settings';

export default BackupSettings;
